type RouteTitleRule = {
  match: (pathname: string) => boolean;
  title: string;
};

const ROUTE_TITLE_RULES: RouteTitleRule[] = [
  { match: (p) => /^\/products\/[^/]+$/.test(p), title: "Product Details" },
  { match: (p) => p.startsWith("/products"), title: "Products" },
  { match: (p) => /^\/producttype\/[^/]+$/.test(p), title: "Product Type Details" },
  { match: (p) => p.startsWith("/producttype"), title: "Product Type" },
  { match: (p) => /^\/productcategory\/[^/]+$/.test(p), title: "Product Category Details" },
  { match: (p) => p.startsWith("/productcategory"), title: "Product Category" },
  { match: (p) => p.startsWith("/servicetype"), title: "Service Type" },
  { match: (p) => p.startsWith("/manufacturer"), title: "Manufacturer" },
  { match: (p) => p.startsWith("/vendor"), title: "Vendor" },
  { match: (p) => p.startsWith("/workorderstage"), title: "Work Order Stages" },
  { match: (p) => p.startsWith("/requested-products"), title: "Requested Products" },
  { match: (p) => p.startsWith("/company"), title: "Company" },
  { match: (p) => p.startsWith("/partners"), title: "Partners" },
  { match: (p) => p.startsWith("/plans"), title: "Subscription Plans" },
  { match: (p) => p.startsWith("/ai-addons"), title: "AI Addons" },
  { match: (p) => p.startsWith("/team"), title: "Team" },
  { match: (p) => p.startsWith("/subscription"), title: "Plan & Billing" },
  { match: (p) => p.startsWith("/ticketing"), title: "Ticketing" },
  { match: (p) => p.startsWith("/gallery"), title: "Gallery" },
  { match: (p) => p.startsWith("/onboard"), title: "Onboard" },
  { match: (p) => p.startsWith("/prompt-library"), title: "Prompt Library" },
  { match: (p) => p.startsWith("/lens"), title: "Lenses" },
  { match: (p) => p.startsWith("/obligations"), title: "Obligations" },
  { match: (p) => p.startsWith("/faqs"), title: "FAQs" },
  { match: (p) => p.startsWith("/settings"), title: "Profile" },
  { match: (p) => p.startsWith("/dashboard"), title: "Dashboard" },
];

export function getRoutePageTitle(pathname: string): string | null {
  const rule = ROUTE_TITLE_RULES.find((r) => r.match(pathname));
  return rule?.title ?? null;
}
